<script>
import { HorizontalBar } from 'vue-chartjs'

const colors = [
  '#1957CD',
  '#0F347B',
  '#46ADE3',
  '#1895A7',
  '#A5E3ED',
  '#44CEA5',
  '#297C63',
  '#AEE0C6',
  '#532C95',
  '#9E9BF0',
  '#6F0C4E',
  '#B2127C',
  '#E1AFEF',
  '#EC3240',
  '#262F35',
  '#A8ACAE',
  '#1957CD',
  '#0F347B',
  '#46ADE3',
  '#1895A7',
  '#A5E3ED',
  '#44CEA5',
  '#297C63',
  '#AEE0C6',
  '#532C95',
  '#9E9BF0',
  '#6F0C4E',
  '#B2127C',
  '#E1AFEF',
  '#EC3240',
  '#262F35',
  '#A8ACAE',
  '#1957CD',
  '#0F347B',
  '#46ADE3',
  '#1895A7',
  '#A5E3ED',
  '#44CEA5',
  '#297C63',
  '#AEE0C6',
  '#532C95',
  '#9E9BF0',
  '#6F0C4E',
  '#B2127C',
  '#E1AFEF',
  '#EC3240',
  '#262F35',
  '#A8ACAE'
]

export default {
  extends: HorizontalBar,
  props: ['chartName', 'apiData', 'fieldData', 'valueField', 'transformKeyFunction', 'barPercentage', 'maxBarThickness', 'categoryPercentage'],
  computed: {
    values: function () {
      let datasetObject = {}
      let datasetData = []
      let datasetColors = []

      this.apiData.forEach((value, index) => {
        const strVal = (this.apiData[index] && this.apiData[index].value)
          ? this.apiData[index].value.toString()
          : ''
        datasetData.push(strVal)
        datasetColors.push(colors[index % 37])
      })

      datasetObject = {
        data: datasetData,
        backgroundColor: datasetColors
      }

      return datasetObject
    },
    labels: function () {
      let labels = []
      this.apiData.forEach((value, index) => {
        const fieldName = this.transformKeyFunction ? this.transformKeyFunction(value.field) : value.field
        labels.push(fieldName)
      })

      return labels
    }
  },
  methods: {
    renderBarChart: function () {
      const opts = {
        legend: {
          display: false
        }
      }

      if (this.barPercentage || this.categoryPercentage || this.maxBarThickness || this.height) {
        const scalesOpts = {}
        if (this.barPercentage) {
          scalesOpts['barPercentage'] = this.barPercentage
        }
        if (this.categoryPercentage) {
          scalesOpts['categoryPercentage'] = this.categoryPercentage
        }
        if (this.maxBarThickness) {
          scalesOpts['maxBarThickness'] = this.maxBarThickness
        }
        if (this.height) {
          scalesOpts['height'] = this.height
        }
        scalesOpts.gridLines = {display: false}

        opts.scales = {
          yAxes: [scalesOpts],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        }
      }

      this.renderChart(
        // data
        {
          labels: this.labels,
          datasets: [this.values]
        },
        opts
      )
    }
  },
  watch: {
    apiData: function () {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.renderBarChart()
    }
  },
  mounted () {
    this.renderBarChart()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/charts/HorizontalBarChart.vue